/**
 * @module lib/vendor
 * @description Bundle common vendor files, which we know won't need any tree-shaking.
 * No need in exporting each function individually. Just a single object will do.
 * This JS file is not processed by Babel!
 */

/**
 * This script is not loaded if `window.tgam.env.inAppView` is true.
 * Measure customer experience and link improvements to business outcomes – with proven science.
 * @see https://www.foresee.com/
 */
function foreseeInit() {
  (function (g) {
    var env = g.tgam.env.isProdOrStage ? "production" : "staging";
    var d = document, am = d.createElement('script'), h = d.head || d.getElementsByTagName("head")[0], fsr = 'fsReady',
    aex = {
    "src": "https://gateway.foresee.com/sites/globeandmail/" + env + "/gateway.min.js",
    "type": "text/javascript",
    "async": "true",
    "data-vendor": "fs",
    "data-role": "gateway"
    };
    for (var attr in aex){am.setAttribute(attr, aex[attr]);}h.appendChild(am);g[fsr] = function () {var aT = '__' + fsr + '_stk__';g[aT] = g[aT] || [];g[aT].push(arguments);};
  })(window);
}

/**
 * ScorecardResearch is part of a company called Full Circle Studies, which is owned by comScore.
 * It provides market research data to website owners through a mixture of online surveys and the use of web beacons.
 * @see http://www.scorecardresearch.com
 */
function comScoreInit() {
  var c_id = '10251187';
  var _comscore = window._comscore = _comscore || [];
  var node = window.document.getElementsByTagName("script")[0];
  var script = window.document.createElement("script");
  if (!node) {
    node = window.document.getElementsByTagName("head")[0];
  }
  _comscore.push({
    c1: "2",
    c2: c_id
  });

  script.type = "text/javascript";
  script.src = "https://sb.scorecardresearch.com/beacon.js";
  script.async = true;
  node.parentNode.insertBefore(script, node);
}

/**
 * Krux is a data management company whose services not only includes data security but also
 * (and this is where krxd comes in) visitor tracking and monetization services
 * (i.e. using your personal information to generate custom tailored ads that are then shown to you).
 * @see https://www.salesforce.com/products/marketing-cloud/data-management/?d=DMP
 * @see http://www.krux.com/
 */
function kruxInit() {
  window.Krux || ((window.Krux = function() {
    window.Krux.q.push(arguments)
  }).q = []);
  (function() {
    var confid = /kct=2/.test(window.location.search) ? "u5q9yugfg" : "I3G0xgk0";
    var k = document.createElement("script"); k.type = "text/javascript"; k.async = true;
    var m,
      src = (m = location.href.match(/\bkxsrc=([^&]+)/)) && decodeURIComponent(m[1]);
    k.src = /^https?:\/\/([a-z0-9_\-\.]+\.)?krxd\.net(:\d{1,5})?\/controltag\//i.test(src) ? src : src === "disable" ? "" :
      (location.protocol === "https:" ? "https:" : "http:") + "//cdn.krxd.net/controltag?confid=" + confid;
    var s = document.getElementsByTagName("script")[0]; s.parentNode.insertBefore(k, s);
  }());
  (function() {
    function retrieve(n) {
      var m, k="kxglobe_"+n,ls=(function(){
        try {
          return window.localStorage;
        } catch(e){
          return null;
        }
      })();
      if (ls) {
        return ls[k] || "";
      } else if (navigator.cookieEnabled) {
        m = document.cookie.match(k+"=([^;]*)");
        return (m && unescape(m[1])) || "";
      } else {
        return "";
      }
    }
    window.Krux.user = retrieve("kuid");
    window.Krux.segments = retrieve("segs") ? retrieve("segs").split(",") : [];
  })();
}

// Do not use ES6 shorthand method definition here
export default {
  foreseeInit: foreseeInit,
  comScoreInit: comScoreInit,
  kruxInit: kruxInit
};
